import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getPartnershipRequests,
  updatePartnershipRequestStatus,
  deletePartnershipRequest,
  GetPartnershipRequestsParams,
} from '@/api/partnershipRequests';

export function usePartnershipRequests(params: GetPartnershipRequestsParams) {
  return useQuery({
    queryKey: ['partnership-requests', params],
    queryFn: () => getPartnershipRequests(params),
    placeholderData: (previousData) => previousData,
  });
}

export function useUpdatePartnershipRequestStatus() {
  const queryClient = useQueryClient();

  return useMutation<
    unknown,
    AxiosError<{ message?: string }>,
    { requestId: number; status: 'Pending' | 'Approved' | 'Rejected'; rejectionReason?: string }
  >({
    mutationFn: ({ requestId, status, rejectionReason }) =>
      updatePartnershipRequestStatus(requestId, status, rejectionReason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['partnership-requests'] });
      // Also invalidate vendors list because an approved request might add a new vendor
      queryClient.invalidateQueries({ queryKey: ['merchants'] });
    },
  });
}

export function useDeletePartnershipRequest() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<{ message?: string }>, number>({
    mutationFn: (requestId) => deletePartnershipRequest(requestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['partnership-requests'] });
    },
  });
}
